import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown'
import { css, styled } from '@mui/material/styles'

export const ContactCountsCellWrapper = styled('div')`
  width: 100%;
  display: flex;
  align-items: flex-start;
`

export const ArrowIconButton = styled(ExpandCircleDownIcon)`
  cursor: pointer;
  margin-right: 5px;
`

export const StatusCountsContainer = styled('div')`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

export const StatusCountContainer = styled('div')`
  display: flex;
  align-items: baseline;
  margin-right: 10px;
  white-space: break-spaces;
  word-wrap: break-word;
`

export const StatusCountDot = styled('div')`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 3px;
  flex: 0 0 auto;
  ${({ color }: { color?: string }) => css`
    background-color: ${color};
  `}
`

export const StatusCountText = styled('div')``
